/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Button from '@mui/material/Button';
import { ExternalLink } from 'react-feather';
import { useStateContext } from '../../../contexts/ContextProvider';
import '../../../App.css'
import { Table} from 'reactstrap';
import UpdateQuestionnaires from './UpdateQuestionnaires';
import DeleteQuestionnaires from './DeleteQuestionnaires';

const QuestionnairesTable = ({ usrDbRoles }) => {
  const { questionnaires, primary } = useStateContext();

  return (
    <>
      {questionnaires.length > 0 ? (
        <>
          <div style={{ overflow: 'scroll', width: '100%' }} className='shadowClass'>
            <Table style={{ textAlign: 'center' }}>
              <thead className="table-primary table-responsive">
                <tr>
                  <th>Descrizione</th>
                  <th>Link</th>
                  {usrDbRoles.includes('GOSP') && (
                    <><th /><th /></>
                  )}
                </tr>
              </thead>
              <tbody>
                {questionnaires.map((questionnaire) => (
                  <tr key={questionnaire.id}>
                    <td>{questionnaire.description}</td>
                    <td>
                      <Button
                        component="a"
                        href={questionnaire.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        size="small"
                        startIcon={<ExternalLink size={16} />}
                        sx={{
                          backgroundColor: primary,
                          color: '#fff',
                          '& .MuiButton-startIcon': { color: 'inherit' },
                          '&:hover': {
                            backgroundColor: primary,
                            color: '#fff',
                            filter: 'brightness(0.92)',
                          },
                        }}
                      >
                        Apri
                      </Button>
                    </td>
                    {usrDbRoles.includes('GOSP') && (
                      <>
                        <td><UpdateQuestionnaires questionnaire={questionnaire} /></td>
                        <td><DeleteQuestionnaires qstId={questionnaire.id} /></td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      ) : (
        <p>Nessun questionario trovato...</p>
      )}
    </>
  );
};

export default QuestionnairesTable;